import { useState, useEffect } from 'react';
import { getHeaderValues } from '../QAChecklistTab/utils';

export const useSpreadsheetTotals = ({
  spreadsheetHandle,
  isMultipleInvoices,
  consignorDetails,
  calculateIfMultipleConsignorsValid,
  setTotalItemValue,
}) => {
  const [netMass, setNetMass] = useState(0);
  const [grossMass, setGrossMass] = useState(0);
  const [itemsCount, setItemsCount] = useState(0);
  const [totalValue, setTotalValue] = useState(0);
  const [itemRows, setItemRows] = useState(0);
  const [itemHeaders, setItemHeaders] = useState(0);
  const [showBulkBtn, setShowBulkBtn] = useState(false);

  const resetTotals = () => {
    setNetMass(0);
    setGrossMass(0);
    setItemsCount(0);
    setTotalValue(0);
    setItemRows(0);
    setItemHeaders(0);
    setTotalItemValue(0);
  };

  useEffect(() => {
    const sumsFunction = (state) => {
      let headers = [
        { name: 'grossMass', update: setGrossMass },
        { name: 'netMass', update: setNetMass },
        { name: 'itemValue', update: setTotalValue },
        { name: 'packageCount', update: setItemsCount },
      ];
      let itemRowsCalc = 0;
      const isArray = Array.isArray(state.rows?.[0]);
      headers = headers.map((obj) => ({
        ...obj,
        value: 0,
        col: isArray ? state.config.findIndex((c) => c.key === obj.name) : undefined,
      }));

      state.rows.forEach((row) => {
        headers.forEach((h) => {
          const key = isArray ? h.col : h.name;
          h.value += isNaN(parseFloat(row[key]?.text)) ? 0 : parseFloat(row[key]?.text);
        });
        itemRowsCalc += (isArray ? row : Object.values(row)).some((cell) => !!cell?.text) ? 1 : 0;
      });

      headers.forEach((h) => {
        h.update(h.value);
        if (h.name === 'itemValue') {
          setTotalItemValue(h.value);
        }
      });

      const uniquePairs = getHeaderValues(state.rows, 'CABIE');
      setItemHeaders(uniquePairs ?? 0);
      setItemRows(itemRowsCalc);
    };

    spreadsheetHandle.current.excelDispatch({
      type: 'setOnUpdate',
      detail: (state) => {
        sumsFunction(state);
        calculateIfMultipleConsignorsValid(state);
      },
    });
  }, [consignorDetails]);

  useEffect(() => {
    itemRows >= 1 && !isMultipleInvoices ? setShowBulkBtn(true) : setShowBulkBtn(false);
  }, [itemRows, isMultipleInvoices]);

  return { netMass, grossMass, itemsCount, totalValue, itemRows, itemHeaders, showBulkBtn, resetTotals };
};
